import { render, staticRenderFns } from "./CertificatesInput.vue?vue&type=template&id=96950a22&"
import script from "./CertificatesInput.vue?vue&type=script&lang=js&"
export * from "./CertificatesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports